import * as React from "react";
import { styled } from "@mui/system";
import MUIInputAdornment from "@mui/material/InputAdornment";
import {
  InputAdornmentProps as InputAdornmentPropsMUI,
  InputAdornmentTypeMap
} from "@mui/material/InputAdornment";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface InputAdornmentProps extends InputAdornmentPropsMUI {
  component?: React.ElementType;
}

const InputAdornmentRoot = styled(MUIInputAdornment, {
  name: "InputAdornment",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));

export const InputAdornment = React.forwardRef<
  HTMLDivElement,
  InputAdornmentProps
>(function InputAdornment(props, ref) {
  return <InputAdornmentRoot {...props} ref={ref} />;
}) as OverridableComponent<InputAdornmentTypeMap<{}, "div">>;
